import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, CircularProgress, Dialog, DialogContent, Grid, Modal, TextField, Toolbar, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';
import { downloadAccountRecievableReport } from '../../redux/Invoice/action';
import { saveFileFromResponse } from '../../utility/helpers/fileDownload';
import { toISOStringUTCEnd } from '../../utility/helpers/commonFunction';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    // p: 3,
};

const AccountsReceivableReportModel = ({ open, close }) => {
    const dispatch = useDispatch();
    const [selectedTimePeriod, setSelectedTimePeriod] = useState('');
    const [fromDate, setFromDate] = React.useState(null);
    const [toDate, setToDate] = React.useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const handleClose = () => {
        close(false);
        setFromDate(null);
        setToDate(null);
        setSelectedTimePeriod('');
    };

    useEffect(() => {
        if (open) {
            setToDate(dayjs());
        }
    }, [open]);

    const handleDownload = async (type) => {
        if (!toDate || dayjs(toDate).format('YYYY-MM-DD') == 'Invalid Date') return toast.error('Please enter to date');

        if (toDate) {
            setShowLoader(true);
            const payload = {
                // toDate: toISOStringUTCEnd(toDate),
                toDate: dayjs(toDate).format('YYYY-MM-DD'),
                format: type,
            };
            const resp = await dispatch(downloadAccountRecievableReport(payload));
            setShowLoader(false);
            // on failure the response interceptor has already shown the server's message (no data, PDF failed, timeout)
            if (resp?.status == 200 && saveFileFromResponse(resp, `accounts-receivable-report.${type}`)) {
                handleClose();
                toast.success('Accounts receivable report exported successfully');
            }
        }
    };

    return (
        <Box>
            <Modal open={open} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
                {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                <Box
                    sx={{
                        ...style,
                        border: 'none',
                        borderRadius: '8px 8px 0px 0px',
                    }}
                    className="modalBodyBoxContainer"
                >
                    <AppBar
                        color="secondary"
                        variant="elevation"
                        sx={{
                            height: '64px',
                            borderRadius: '8px 8px 0px 0px !important',
                            paddingRight: '0px !important',
                        }}
                    >
                        <Toolbar variant="regular">
                            <Typography variant="h6" width={'98%'} color={'white'}>
                                Export Accounts Receivable Report
                            </Typography>
                            <Stack direction={'row'}>
                                <div onClick={handleClose} style={{ cursor: 'pointer', height: '32px' }}>
                                    <CloseIcon sx={{ fill: 'white', fontSize: 32 }} />
                                </div>
                            </Stack>
                        </Toolbar>
                    </AppBar>
                    <Container
                        // gap={2}
                        disableGutters
                        style={{
                            marginTop: '64px',
                        }}
                    >
                        <Grid
                            container
                            // spacing={3}
                            style={{
                                scrollbarColor: 'blue',
                                scrollbarWidth: 'thin',
                                overflowY: 'auto',
                                maxHeight: '78vh',
                            }}
                            padding={'24px 24px 0 24px'}
                        >
                            <Grid container xs={12}>
                                <Grid item xs={12}>
                                    <Stack>
                                        <div>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    fontWeight: 500,
                                                    fontSize: '16px',
                                                    lineHeight: '24px',
                                                    marginBottom: '8px',
                                                }}
                                            >
                                                Select Date
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    sx={{ width: '100%' }}
                                                    value={toDate}
                                                    onChange={(newValue) => {
                                                        setToDate(dayjs(dayjs(newValue).format('YYYY-MM-DD')));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item container justifyContent={'space-between'} p={3}>
                            <div>
                                <Stack spacing={2} direction="row">
                                    <Button variant="outlined" color="primary" onClick={handleClose}>
                                        CANCEL
                                    </Button>
                                </Stack>
                            </div>

                            <div>
                                <Stack spacing={2} direction="row">
                                    <Button variant="contained" color="primary" onClick={() => handleDownload('pdf')}>
                                        EXPORT PDF
                                    </Button>
                                    <Button variant="contained" color="primary" onClick={() => handleDownload('csv')}>
                                        EXPORT CSV
                                    </Button>
                                </Stack>
                            </div>
                        </Grid>
                    </Container>
                </Box>
                {/* </form> */}
            </Modal>
            <Dialog open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default AccountsReceivableReportModel;
